import React from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import HideAppBar from "../../widgets/header/HideAppBar";
import {Box, Button, Chip, Container, Paper, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import {innerStyle} from "../../../styles/pages/home/MaterialYouBaseStyle";
import {CancelTwoTone, CheckCircleTwoTone, Google as GoogleIcon} from "@mui/icons-material";
import makeStyles from '@mui/styles/makeStyles';
import useFetchGoogleStatus from "./useFetchGoogleStatus";
import {BASE_NAME} from "../../../services/utils/ApiUrls";
import {getAccountInfo} from "../../../utils/GenericUtils";

const useIf = (condition, element) => (condition ? element : null);
const useStyles = makeStyles(() => ({
    title: {
        fontWeight: "bold",
        fontSize: "1.4rem",
    },
    subTitle: {
        color: "gray",
    },
    mt20: {
        marginTop: 20
    },
}));

const Impostazioni = () => {
    const classes = BaseStyle();
    const classesInner = innerStyle();
    const classesOuter = useStyles();


    const {data, loading, error, firstLoad} = useFetchGoogleStatus();

    const handleClick = (type) => {
        if (type === 'connect')
            window.open(BASE_NAME + 'google-auth/login?username=' + getAccountInfo().username + '&redirectType=sync')
            // window.open(BASE_NAME + 'google-auth/login?username=null&redirectType=login')
        else
            window.open(BASE_NAME + 'google-auth/logout')
    }


    return (
        <React.Fragment>
            <main className={classes.main}>
                <HideAppBar title={"Gestione categorie"}/>
                <Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <Paper className={classesInner.paper} component={"section"}>
                                <Typography className={classesOuter.title}>
                                    Associazione account Google
                                </Typography>
                                <Typography className={classesOuter.subTitle}>
                                    Accedi con Google per un'esperienza di login semplice, veloce e sicura. Utilizzando
                                    un'unica utenza, potrai sincronizzare automaticamente il tuo calendario e tutti i
                                    tuoi eventi, assicurandoti di non perderne nemmeno uno. Un accesso rapido ed
                                    efficiente per una gestione fluida e senza interruzioni.
                                </Typography>

                                <Box display="flex" alignItems="center" justifyContent="space-evenly"
                                     alignContent="center" marginTop={5}>
                                    <Typography>
                                        Stato associazione:
                                    </Typography>

                                    <Chip
                                        icon={data?.connected ? <CheckCircleTwoTone style={{color: "white"}}/> :
                                            <CancelTwoTone style={{color: "white"}}/>}
                                        label={data?.connected ? "Associato con successo" : "Associazione non eseguita"}
                                        style={{
                                            backgroundColor: data?.connected ? "limegreen" : "red",
                                            color: "white",
                                            fontWeight: "bold"
                                        }}
                                    />
                                </Box>

                                <Box display="flex" justifyContent="center" marginTop={5}>
                                    {useIf(!data?.connected, (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<GoogleIcon/>}
                                            style={{borderRadius: 20}}
                                            onClick={() => {
                                                handleClick("connect")
                                            }}
                                        >
                                            Accedi con Google
                                        </Button>
                                    ))}
                                    {useIf(data?.connected, (
                                        <Button
                                            variant="contained"
                                            startIcon={<GoogleIcon/>}
                                            style={{borderRadius: 20, backgroundColor: "red", color: "white"}}
                                            onClick={() => {
                                                handleClick("disconnect")
                                            }}
                                        >
                                            Esci da Google
                                        </Button>
                                    ))}
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </main>
        </React.Fragment>
    );
};

export default React.memo(Impostazioni);
